// extracted by mini-css-extract-plugin
export var addButton = "_h8-0";
export var border = "_h8-8";
export var check = "_h8-h";
export var danger = "_h8-6";
export var dropdownContainer = "_h8-1";
export var editModalBody = "_h8-j";
export var footerContainer = "_h8-i";
export var fullWidth = "_h8-a";
export var hide = "_h8-9";
export var icon = "_h8-3";
export var input = "_h8-7";
export var inputFlex = "_h8-b";
export var inputWrapper = "_h8-c";
export var manualFocus = "_h8-5";
export var optionButton = "_h8-4";
export var pillWrapper = "_h8-e";
export var pointer = "_h8-2";
export var showOverflow = "_h8-f";
export var tagsFlex = "_h8-d";
export var xButton = "_h8-g";